const MILLISECONDS_IN_SECOND = 1000;

export const addSecondsToDate = (seconds: number, date: Date = new Date()): Date => {
  return new Date(date.getTime() + seconds * MILLISECONDS_IN_SECOND);
}
